import { LANGUAGE } from '@/constants'

/**
 * 默认多语言处理
 * 首次访问：以浏览器语言为主。支持简中、台湾繁中
 * 其他语言默认显示简中
 *
 * 二次访问：以用户上次访问时的语言为主
 * @returns
 */

export const DEFAULT_LANG = 'en'
export function getLocalLang() {
  // 查询浏览器多语言
  const language = navigator.language === 'zh' ? 'zh-CN' : navigator.language
  const browserLang = LANGUAGE.map((it) => it.lang).includes(language) ? language : DEFAULT_LANG
  // 本地多语言
  const local = window.localStorage.getItem('i18nextLng') || browserLang
  // 本地多语言是否在维护的多语言
  /**
   * TODO:
   * i18n的有可能不在language吗？
   */
  const localInLangs = LANGUAGE.find((it) => it.lang === local || it.languageType === local)
  const localLang = LANGUAGE.filter((item) => {
    if (localInLangs) {
      return item.lang === local
    }

    return item.lang === DEFAULT_LANG
  })

  return localLang
}
